import React from "react";
import { COLORS } from "rylak-common/src/constants";

const complaintLineSize = "1px";

export default function SpecialItemLine({ width, height, top, left = 38 }) {
    return (
        <div
            style={{
                position: "absolute",
                background: COLORS.GRAY,
                width: width || complaintLineSize,
                height: height || complaintLineSize,
                top: top,
                left: left,
            }}
        />
    );
}
